// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"b1ead214","341":"d9fcc8d4","358":"6fdeb9cf","361":"dce27c07","468":"96a81b04","558":"c29b76b8","571":"ae3a3a98","660":"e2348723","661":"98e17ad5","717":"22f0affa"}[chunkId] + ".chunk.js";
};